import { Injectable } from '@angular/core';
import { MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';

import { RememberPasswordComponent } from './remember-password.component';


@Injectable()
export class RememberPasswordService {

  constructor(private dialog: MatDialog) { }

  openDialog(type: string) {
    let dialogRef: MatDialogRef<RememberPasswordComponent>;
    dialogRef = this.dialog.open(RememberPasswordComponent, { panelClass: 'dialog', maxWidth: '450px' });
    dialogRef.componentInstance.type = type;
    return dialogRef.afterClosed();
  }

}
